import { render, staticRenderFns } from "./header-nav-menu.vue?vue&type=template&id=65d7d8e9&"
import script from "./header-nav-menu.vue?vue&type=script&lang=ts&"
export * from "./header-nav-menu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports